import { render, staticRenderFns } from "./MyntraSummary.vue?vue&type=template&id=662a0738&lang=pug"
import script from "./MyntraSummary.js?vue&type=script&lang=js&external"
export * from "./MyntraSummary.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports